import { scrlStCls } from "../../toc/orderBook/obConstants";

export const ObScrollService = (readyToFix: boolean) => {
	let TargetContainer = document.getElementById(scrlStCls.pContId), //conatiner where synthetic event attached
		targetEle: any = TargetContainer?.getElementsByClassName(scrlStCls.toContext) || [], //upto what context block to be freezed
		getRefOffset: any = TargetContainer?.getElementsByClassName(scrlStCls.pOffset) || [], //fixed header
		getFreezeRef: any = TargetContainer?.getElementsByClassName(scrlStCls.freeze) || [], //block to be freezed
		getRefBoundClient = getRefOffset.length ? getRefOffset[0].getBoundingClientRect() : null, //fixed header bounding dimensions used for ref
		fixedEleBottom = TargetContainer?.querySelector(".fixed .util_cont")?.getBoundingClientRect().bottom;

	if (targetEle.length && readyToFix) {
		//loop all context blocks, when its top and bottom positions near to table fixed header freeze the required block
		for (let i = 0; i < targetEle.length; i++) {
			const ele = targetEle[i].getBoundingClientRect(),
				freezeRef = getFreezeRef[i].getBoundingClientRect();

			//fixed header row top and height and row to be freezed height
			let topSpacing = i - 1 + (fixedEleBottom || 0) + (getRefBoundClient?.height || 0) + freezeRef.height;

			if (ele.bottom > topSpacing && ele.top < topSpacing && getFreezeRef[i].className.indexOf(scrlStCls.fixClass) < 0) {
				getFreezeRef[i].className += " " + scrlStCls.fixClass;
			} else if (ele.top > topSpacing || ele.bottom < 0) {
				//if positions go to negative range remove the class
				getFreezeRef[i].classList.remove(scrlStCls.fixClass);
			}
		}
	}
};
